import React, { Suspense } from 'react';

export interface DynamicOptions {
  ssr?: boolean;
  loading?: (loadingProps: { error?: Error; isLoading?: boolean; pastDelay?: boolean; retry?: () => void }) => React.ReactNode;
}

export function dynamic<T extends React.ComponentType<any>>(
  loader: () => Promise<T | { default: T }>,
  options?: DynamicOptions,
): React.ComponentType<React.ComponentProps<T>> {
  const LazyComponent = React.lazy(async () => {
    const mod = await loader();
    if ('default' in mod) {
      return mod;
    }
    return { default: mod as any };
  });

  const DynamicWrapper: React.FC<React.ComponentProps<T>> = (props) => {
    const Loading = options?.loading;
    return (
      <Suspense fallback={Loading ? <Loading isLoading={true} /> : null}>
        <LazyComponent {...(props as any)} />
      </Suspense>
    );
  };

  DynamicWrapper.displayName = 'DynamicComponent';
  return DynamicWrapper as any;
}

export default dynamic;
